import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCollapse,
  CSmartTable,
} from '@coreui/react-pro'

import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import TeamService from 'src/service/TeamService'
import EditForm from './EditForm'
import Notify from '../Notify'
import CommonService from 'src/service/CommonService'

const STATUS_ACTIVE = 1
const STATUS_INACTIVE = 0
const API_URL = process.env.REACT_APP_API_URL

const createDataObject = (id) => {
  return { id }
}

const Table = ({
  gradeList,
  teamCategoryList,
  users,
  setUsers,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnFilter,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnFilter,
  columnSorter,
}) => {
  const [loading, setLoading] = useState(false)
  const [visibleHorizontal, setVisibleHorizontal] = useState(false)
  const [selectedTeamId, setSelectedTeamId] = useState(0)
  const [details, setDetails] = useState([])
  const [handleYes, setHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)

  const columns = [
    { label: 'Team Code', key: 'sn' },
    { label: 'Team Logo', key: 'image' },
    { label: 'Team Name', key: 'team_name' },
    { label: 'Comp Name', key: 'comp_name' },
    { key: 'show_details', label: 'Actions', filter: false, sorter: false },
  ]

  const getBadge = (status) => {
    switch (status) {
      case STATUS_ACTIVE:
        return 'success'
      case STATUS_INACTIVE:
        return 'warning'
      default:
        return 'primary'
    }
  }

  const toggleDetails = (index) => {
    setSelectedTeamId(index)
    const position = details.indexOf(index)
    let newDetails = details.slice()
    if (position !== -1) {
      newDetails.splice(position, 1)
    } else {
      newDetails = [...details, index]
    }
    setDetails(newDetails)
  }

  const deleteTeam = (id) => {
    setLoading(true)
    const data = createDataObject(id)
    const position = details.indexOf(id)
    let newDetails = details.slice()
    newDetails.splice(position, 1)
    setDetails(newDetails)
    TeamService.deleteTeam(data)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent('Failed to delete team', 'error')
        }
        setLoading(false)
      })
      .catch((error) => {
        ToastComponent('An error occurred', 'error')
        setLoading(false)
      })
  }

  const handleCancel = () => setShowConfirm(false)

  const handleConfirm = () => {
    deleteTeam(tableId)
    setShowConfirm(false)
  }

  const areYouSureModal = (id) => {
    const data = createDataObject(id)
    CommonService.checkItemExists(data).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          ToastComponent(res.message, 'error')
        } else {
          setShowConfirm(true)
          setTableId(id)
        }
      }
    })
  }

  useEffect(() => {
    const offset = itemsPerPage * activePage - itemsPerPage
    fetchUsers(offset, itemsPerPage, activePage, columnFilter, columnSorter)
  }, [activePage, columnFilter, columnSorter, itemsPerPage, fetchUsers])

  return (
    <>
      <CSmartTable
        columns={columns}
        columnFilter={{ external: true }}
        columnSorter={{ external: true }}
        scopedColumns={{
          image: (item) => (
            <td>
              {item.image ? (
                <img
                  src={`${API_URL}uploads/team_sponsor/${item.image}`}
                  alt="team_sponsor"
                  width="50"
                  height="50"
                />
              ) : (
                <img
                  src={`${API_URL}uploads/game_logo/${item.game_logo}`}
                  alt="game_logo"
                  width="50"
                  height="50"
                />
              )}
            </td>
          ),
          svalue: (item) => <td>${item.svalue}m</td>,
          is_active: (item) => (
            <td>
              <CBadge color={getBadge(item.is_active)}>
                {item.is_active === STATUS_ACTIVE ? 'Activated' : 'Deactivated'}
              </CBadge>
            </td>
          ),
          created_at: (item) => <td>{moment(item.created_at).format('D.MM.YYYY')}</td>,
          show_details: (item) => (
            <td className="py-2">
              <CButton
                color="primary"
                variant="outline"
                shape="square"
                size="sm"
                onClick={() => toggleDetails(item.id)}
              >
                {details.includes(item.id) ? 'Hide' : 'Manage'}
              </CButton>
            </td>
          ),
          details: (item) => (
            <CCollapse visible={details.includes(item.id)}>
              <CCardBody>
                <CButton
                  size="sm"
                  color="success"
                  className="ml-1"
                  onClick={() => setVisibleHorizontal(!visibleHorizontal)}
                  aria-expanded={visibleHorizontal}
                  aria-controls="collapseEdit"
                >
                  Edit
                </CButton>
                <CButton
                  size="sm"
                  color="danger"
                  className="ml-3"
                  onClick={() => areYouSureModal(item.id)}
                >
                  Delete
                </CButton>
                <CCollapse id="collapseEdit" horizontal visible={visibleHorizontal}>
                  <CCard className="mb-4">
                    <CCardHeader>
                      <strong>Edit Team</strong>
                    </CCardHeader>
                    <CCardBody>
                      <EditForm
                        teamId={item.id}
                        selectedTeamId={selectedTeamId}
                        gradeList={gradeList}
                        teamCategoryList={teamCategoryList}
                        fetchUsers={fetchUsers}
                        toggleDetails={toggleDetails}
                      />
                    </CCardBody>
                  </CCard>
                </CCollapse>
              </CCardBody>
            </CCollapse>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{ external: true }}
        paginationProps={{
          activePage: activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{ hover: true, responsive: true }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this?"
      />
    </>
  )
}

export default Table
